const fns = {

    funcao5(){

    },


    funcao6(){

    },


}
export default fns